'use client';

import { EyeHide, EyeShow } from '@velocity-exchange/icons';
import useCurrentSettings from '../../hooks/useCurrentSettings';
import IconButton, {
	IconButtonProps,
} from 'src/components/primitives/IconButton/IconButton';

type Props = Omit<Partial<IconButtonProps>, 'icon' | 'children' | 'onClick'>;

export default function ShowHideAccountValuesButton({
	size = 'sm',
	variant = 'tertiary',
	...rest
}: Props) {
	const [currentSettings, setCurrentSettings] = useCurrentSettings();
	const { showAccountValues } = currentSettings;

	return (
		<IconButton
			size={size}
			variant={variant}
			onClick={(e) => {
				setCurrentSettings({
					...currentSettings,
					showAccountValues: !showAccountValues,
				});

				e.stopPropagation();
			}}
			icon={showAccountValues ? EyeShow : EyeHide}
			{...rest}
		/>
	);
}
